export * from "./FARC";
export * from "./ELN";
export * from "./EPL";
export * from "./M19";

export const armedGroupsItems = {
  FARC: {
    path: "/sociales/movimientos-guerrilleros/farc",
  },
  ELN: {
    path: "/sociales/movimientos-guerrilleros/eln",
  },
  EPL: {
    path: "/sociales/movimientos-guerrilleros/epl",
  },
  "M-19": {
    path: "/sociales/movimientos-guerrilleros/m-19",
  },
};
